var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHorecaColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "190px",
    height: "150px",
    viewBox: "0 0 190 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration / Horeca/Color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.05104327e-07%",
    y1: "22.2723942%",
    x2: "99.999575%",
    y2: "27.7091798%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-20.0%",
    y: "-25.1%",
    width: "140.0%",
    height: "150.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M128.768414,12.2830351 C100.380956,-4.09434504 54.2723311,-4.09434504 25.8848724,12.2830351 C2.03268802,26.0568314 -0.234948905,56.4599718 0.0170108026,73.7612045 C0.10099737,78.464452 0.10099737,97.3614279 0.0170108026,102.400622 C-0.0669757646,109.119547 0.352957072,114.578664 0.352957072,117.35022 C0.352957072,118.442045 1.86471524,119.281914 3.79640622,119.281914 C21.4335851,119.3659 98.4492587,122.053476 128.684422,104.584271 C142.878152,96.3535877 150.017761,85.6033064 150.017761,74.853026 C150.017761,69.2259263 149.933031,47.5573936 150.017761,42.0142804 C150.101005,31.3479868 143.04613,20.5137186 128.768414,12.2830351 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.7%",
    y: "-7.1%",
    width: "111.3%",
    height: "114.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "35.4017177%",
    y1: "46.6292169%",
    x2: "69.4231387%",
    y2: "52.2471952%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#908CCF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.0391058%",
    y1: "48.6251312%",
    x2: "93.8547498%",
    y2: "50.9165818%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8CC6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "40.5521964%",
    y1: "46.6292169%",
    x2: "62.5703829%",
    y2: "52.2471952%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A8DCC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "18.3774891%",
    y1: "46.6292169%",
    x2: "92.0740196%",
    y2: "52.2471952%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C8DC9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.0391058%",
    y1: "48.8794078%",
    x2: "93.8547498%",
    y2: "50.7470636%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25EBA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2.48871514%",
    y1: "50.0463747%",
    x2: "93.854749%",
    y2: "50.4516086%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9459AA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M124.401876,73.4252763 L30.0009766,83.6716347 C30.0009766,51.3088119 30.0009766,37.4510289 30.0009766,42.0982856 C30.0009766,49.0691707 34.6202373,56.0400546 43.8587587,61.4151949 C62.2518148,72.0814885 92.15103,72.0814885 110.628073,61.4151949 C119.782607,56.1240411 124.401869,49.1531592 124.485855,42.1822742 C124.429864,37.4790267 124.401871,47.8933608 124.401876,73.4252763 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84848571%",
    y1: "49.4736888%",
    x2: "96.9696952%",
    y2: "49.4736878%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84848571%",
    y1: "49.4736888%",
    x2: "96.9696952%",
    y2: "49.4736878%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.884801,12.2830354 C54.272259,-4.09434498 100.380881,-4.09434498 128.768339,12.2830354 C157.155797,28.7444026 157.071811,55.2841562 128.768339,71.5775496 C98.5331756,89.0467547 21.5175002,86.3591852 3.88032175,86.2751987 C1.94863082,86.2751987 0.436872603,85.4353368 0.436872603,84.3435115 C0.184912901,74.0971506 -4.35036209,29.7522404 25.884801,12.2830354 Z M118.52198,18.2460819 C95.6776344,5.06019118 58.6395609,5.06019118 35.7112296,18.2460819 C12.7828983,31.4319726 12.7828983,52.8485469 35.7112296,66.0344376 C58.5555756,79.2203283 95.6776344,79.2203283 118.52198,66.0344376 C141.450312,52.8485469 141.450312,31.4319726 118.52198,18.2460819 Z M43.7741373,22.7813342 C62.2511811,12.1150407 92.1504073,12.1150407 110.543464,22.7813342 C129.020508,33.4476276 129.020508,50.6648732 110.543464,61.3311667 C92.0664204,71.9974601 62.1671942,71.9974601 43.7741373,61.3311667 C25.3810804,50.6648732 25.2970935,33.4476276 43.7741373,22.7813342 Z M81.5680905,22.2774145 L41.9264363,45.2057458 L49.4012376,49.5730477 L65.5266583,40.2505404 L80.1403215,48.7331821 L64.0988893,57.9717041 L71.5316875,62.315 L111.131368,39.3266863 L103.656562,34.9593843 L87.61513,44.2818948 L73.0014636,35.8832385 L89.042899,26.6447164 L81.5680905,22.2774145 Z",
    id: "path-14"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.0%",
    y: "-1.7%",
    width: "102.0%",
    height: "103.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-15"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration-/-Horeca/Color",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-126",
    transform: "translate(19.986275, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.769391,22.3040312 C100.381932,5.92665106 54.2733077,5.92665106 25.885849,22.3040312 C2.03366458,36.0778275 -0.233972343,66.4809679 0.0179873651,83.7822006 C0.101973932,88.4854481 0.101973932,107.382424 0.0179873651,112.421618 C-0.0659992021,119.140543 0.353933634,124.59966 0.353933634,127.371216 C0.353933634,128.463041 1.86569181,129.30291 3.79738278,129.30291 C21.4345616,129.386896 98.4502353,132.074472 128.685399,114.605267 C142.879128,106.374584 150.018738,95.6243025 150.018738,84.8740221 C150.018738,79.2469224 149.934008,57.5783897 150.018738,52.0352765 C150.101981,41.3689829 143.047107,30.5347147 128.769391,22.3040312 Z",
    id: "Glow",
    fill: "url(#linearGradient-1)",
    opacity: 0.699999988,
    filter: "url(#filter-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Body"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Vector",
    fill: "url(#linearGradient-5)",
    points: "103.656666 35.043396 87.6152344 44.3659035 87.6152344 59.147541 103.656666 59.147541"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Vector",
    fill: "url(#linearGradient-6)",
    points: "89.0433212 26.644768 81.5685129 22.2774658 40.4951172 44.979489 48.0821678 55.8180923 93.0128479 34.2394172"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Vector",
    fill: "#6A7ABF",
    points: "89.0431647 26.6447678 81.5683594 22.2774658 81.5683594 32.6918011 89.0431647 32.6918011"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Vector",
    fill: "url(#linearGradient-7)",
    points: "87.6156158 44.3658818 73.0019531 35.8832397 73.0019531 63.1788712 87.6156158 63.1788712"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Vector",
    fill: "url(#linearGradient-8)",
    points: "64.0996094 58.0557229 80.1410408 48.7332153 80.1410408 65.1105957 64.0996094 65.1105957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.768337,12.2853538 C100.380879,-4.09202549 54.2722582,-4.09202549 25.8848008,12.2853538 C-4.35036205,29.754558 0.184912942,74.0994647 0.436872634,84.345825 C0.436872634,85.4376503 1.94863073,86.2775165 3.8803217,86.2775165 C21.5174994,86.3615031 98.5331739,89.0490674 128.768337,71.5798632 C157.07181,55.28647 157.155794,28.746721 128.768337,12.2853538 Z",
    id: "Vector",
    fill: "url(#linearGradient-9)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-10)",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.100000001,
    fill: "#000000",
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.543875,22.7813363 C92.1508179,12.1150429 62.2515917,12.1150429 43.7745479,22.7813363 C25.2975041,33.4476297 25.381491,50.6648753 43.7745479,61.3311688 C62.1676048,71.9974622 92.066831,71.9974622 110.543875,61.3311688 C129.020919,50.6648753 129.020919,33.4476297 110.543875,22.7813363 Z M71.5740988,62.339005 L64.0992999,57.9717062 L80.1407321,48.7331842 L65.5270689,40.2505425 L49.4016482,49.5730498 L41.9268469,45.2057479 L81.5685011,22.2774166 L89.0433096,26.6447185 L73.0018742,35.8832406 L87.6155406,44.2818969 L103.656973,34.9593864 L111.131778,39.3266884 L71.4901135,62.339005 L71.5740988,62.339005 Z",
    id: "Top",
    fill: "url(#linearGradient-12)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Top"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-13)",
    xlinkHref: "#path-14"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-15)",
    xlinkHref: "#path-14"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorecaColor);
export default __webpack_public_path__ + "static/media/HorecaColor.6fd4238e70c2b8623e745f735cf480a1.svg";
export { ForwardRef as ReactComponent };